// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"438":"388e0292","986":"ab4e82c3"}[chunkId] + ".css";
};